import { Component, OnInit, ViewChild, signal } from '@angular/core';
import { SalesService } from '../../services/sales.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CabinetService } from '../../services/cabinet.service';
import { CommonModule, Location } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { timestampFormat } from '../../../../app/config/moment';
import { PaginationComponent } from '../../common/pagination/pagination.component';

@Component({
  selector: 'app-sales-genearatereport',
  standalone: true,
  imports: [CommonModule,PaginationComponent,MatInputModule,MatDatepickerModule,MatNativeDateModule],
  templateUrl: './sales-genearatereport.component.html',
  styleUrls: ['./sales-genearatereport.component.scss', '../../../app.component.scss']

})


export class SalesGenearatereportComponent {
  @ViewChild(PaginationComponent) paginationView: PaginationComponent;
  public period: any[] = [
    { period: "Sales Order", value:"sales_order" },
    { period: "Consumed Implants", value:"consumed" },
    { period: "Missing Implants", value:"missing" },
    { period: "Expired Implants" ,value:"expired"},
    { period: "Transferred Stocks" ,value:"transferred"}
  ];

  public timestampFormat = timestampFormat;

  public detailType: string = '';
  public type: string = '';
  public storeDetails : any = []
  public store_Id: string = "";
  public stockId: string = "";
  public month_interval: string = "";
  public stockNames: any;
  public storeNames: any = [];
  public startDate: any;
  public endDate: any;
  tableHeadings: string[] = [];
  modifiedHeadings: string[] = [];
  public salesProducts: any = [];
  public paginationData: any;
  public currentPage: number = 1;

  public changedStoreName: string;
  changedStorePeriod: string = '';
  public currentStoreId: string;
  cabinet: any;

  constructor(public salesService: SalesService,public cabinetService: CabinetService,public location: Location,private route: ActivatedRoute,private router: Router) { }

  isDropDown = signal(false);
  isDropDownPeriod = signal(false); 

  ngOnInit() {
    this.getStoreCabinets()
  }

   onStoreNameChange(id: string, name: string) {
    this.currentStoreId = id;
    this.changedStoreName = name;
    this.isDropDown.set(false);
  }

  goBack(){
    this.location.back();
  }

  onStorePeriodChange(period: any) {
    this.changedStorePeriod = period.value; 
    this.isDropDownPeriod.set(false);
  }

  onStoreName(id: string, name: string){
    this.currentStoreId = id;
    this.changedStoreName = name;
    if (this.currentStoreId) {
    }
  }

  getStoreCabinets(){
    this.cabinetService.getStoreNames().subscribe(res => {
      this.storeNames = res.data;
      if (this.storeNames) {
        this.storeNames.unshift({ id: 'all', name: 'All' });
        this.changedStoreName = this.storeNames[0].name;
        this.currentStoreId = this.storeNames[0].id;
      }
    });
  }

  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    if(type == 'start'){
      this.startDate = timestampFormat(event.value, "YYYY-MM-DD");
    }else{
      this.endDate = timestampFormat(event.value, "YYYY-MM-DD");
    }
  }
  
  generateReport(){
    let data = {
      startDate: this.startDate,
      endDate: this.endDate,
      storeId: this.currentStoreId === 'all' ? '' : this.currentStoreId,
      reportType:this.changedStorePeriod.replaceAll(" ", "")
    }
    this.salesService.getSalesProducts(data.reportType, data.storeId,1, data.startDate, data.endDate).subscribe((response:any)=>{
      const data = response.data;
      if (data && data.stocks) {
        this.paginationData = data.stocks;
        this.paginationData.totalPage = Math.floor(data.stocks.total / 10);
        this.salesProducts = data.stocks.data;
        this.tableHeadings = Object.keys(data.stocks.data[0]);
        this.modifiedHeadings = this.tableHeadings.map(heading => this.capitalizeAndReplace(heading));
      } else if (data){
        this.paginationData = response.data;
        this.paginationData.totalPage = Math.floor(response.data.total / 10);
        this.salesProducts = data.data;
        this.tableHeadings = Object.keys(this.salesProducts[0]);
        this.modifiedHeadings = this.tableHeadings.map(heading => this.capitalizeAndReplace(heading));
      } else {
        console.error('No sales orders data available');
      }
    },(err) => {
      console.log(err);
    })
  }


  getQueryPage(event:any){
    console.log(event);
    this.currentPage = event;
    this.generateReport();
  }

  capitalizeAndReplace(heading: string): string {
    // Split heading by underscore and capitalize each word
    const words = heading.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1));
    // Join words with space
    let formattedHeading = words.join(' ');
    // Replace "Store Name" with "Store", "Warehouse Name" with "Warehouse", and "Rfid" with "RFID"
    if (formattedHeading === "Store Name" || formattedHeading === "Warehouse Name") {
      formattedHeading = formattedHeading.split(' ')[0];
    } else if (formattedHeading === "Rfid") {
      formattedHeading = "RFID";
    }
    return formattedHeading;
  }

  downloadSalesRecords(type: string, storeId: string){
    if (storeId && type) {
      this.salesService.downloadSalesRecords(type, storeId).subscribe((res) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(res);
        link.download = `${type}`;
        link.click();
      });
    } else {
      console.error('StoreId or type is undefined or null');
    }
  }


}


// tableHeaders: {
//   salesOrder: {
//       headers: ["product name", "product code"]
//   }
// }